interface AdminTableSkeletonProps {
  rows?: number;
  cols?: number;
}

export function AdminTableSkeleton({ rows = 8, cols = 6 }: AdminTableSkeletonProps) {
  return (
    <div className="overflow-x-auto animate-pulse">
      <table className="w-full">
        <thead>
          <tr className="bg-secondary/50 border-b border-border">
            {Array.from({ length: cols }).map((_, i) => (
              <th key={i} className="text-left px-4 py-3">
                <span className="h-4 w-20 bg-muted rounded inline-block" />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIdx) => (
            <tr key={rowIdx} className="border-b border-border">
              {Array.from({ length: cols }).map((_, colIdx) => (
                <td key={colIdx} className="px-4 py-3">
                  <span
                    className="h-4 bg-muted rounded inline-block"
                    style={{ width: colIdx === 0 ? 120 : colIdx === cols - 1 ? 80 : 100 }}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
